import { Theme, useMediaQuery } from '@mui/material';

// Запрос, который никогда не совпадает — фолбэк, когда темы нет в дереве
const NEVER_MATCHES = '@media (max-width:0px)';

/**
 * Ниже ли текущая ширина порога мобильной оболочки (< lg = 1200px).
 * Единственный источник правды о переключении rail↔mobile.
 *
 * Отвечает ТОЛЬКО за навигацию. Плотность контента и прижатые панели живут на
 * своих порогах — см. `useIsCompactChrome` (< 900) и `useIsTouchDensity`
 * (< 750) в `useResponsiveTier`. Раньше все три решения висели на 1200, и
 * телефонные приёмы включались на ноутбуке.
 *
 * Тема берётся через колбэк useMediaQuery. Если ThemeProvider отсутствует в
 * дереве (напр. в изолированных unit-тестах компонентов), theme === null —
 * тогда возвращаем false (десктоп) вместо падения на `theme.breakpoints`.
 */
export const useIsMobileShell = (): boolean =>
  useMediaQuery(
    theme => (theme as Theme | null)?.breakpoints.down('lg') ?? NEVER_MATCHES
  );
